import { MutationTree } from "vuex";
import PropertyFinanceStoresTypes from "./property-finance-types.store";
import Vue from "vue";
import { IPropertyEditState } from "../property-states.store";
import { IPropertyPublicUtilityModel,PropertyPublicUtilityModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";

const propertyFinanceMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
		[PropertyFinanceStoresTypes.Set.CHARGE_ELEMENT]: (
			state: IPropertyEditState,
			charges: any
		) => {
			state.property.ChargeElements = charges;
		},		
		[PropertyFinanceStoresTypes.Set.UPDATE_NEW_PUBLIC_UTILITY]: (
			state: IPropertyEditState,
			param: any
		) => {
			//param { field, value}
			const publicUtilities = state.property.PublicUtilities;			

			if(publicUtilities.length == 0)
			{
				const newPublicUtilities: IPropertyPublicUtilityModel = new PropertyPublicUtilityModel();
				newPublicUtilities.PropertyId = state.property.Id;
				newPublicUtilities.ItemState = itemStateConstant.Added;
				newPublicUtilities[param.field] =  param.value;

				publicUtilities.push(newPublicUtilities);
			}
			else {
				const publicUtitlity = publicUtilities[0];

				publicUtitlity.ItemState = publicUtitlity.Id == 0 ? itemStateConstant.Added : itemStateConstant.Modified;
				publicUtitlity[param.field] =  param.value;
			}

			Vue.set(state.property, "PublicUtilities", publicUtilities);
		},
	};

export default propertyFinanceMutations;
